import { initDatadogRumIfAllowed } from './initDatadogRum'
import { loadZendeskWidgetIfAllowed } from './loadZendeskWidget'

/** Start or stop Datadog RUM and Zendesk based on whether the current route allows tracking. */
export function initThirdPartyTrackersIfAllowed(): void {
  initDatadogRumIfAllowed()
  void loadZendeskWidgetIfAllowed()
}
